import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "../styles/AvwakinDevelopmentPage.css";
import logo from "../assets/AvwakinDevelopmentLogo.png";

function AvwakinNavBar() {
  const [activeSection, setActiveSection] =
    useState("");

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "services",
        "process",
        "build",
        "contact",
      ];

      const scrollPosition =
        window.scrollY + 160;

      let currentSection = "";

      for (const sectionId of sections) {
        const section =
          document.getElementById(
            sectionId
          );

        if (!section) {
          continue;
        }

        const sectionTop =
          section.offsetTop;

        const sectionBottom =
          sectionTop +
          section.offsetHeight;

        if (
          scrollPosition >= sectionTop &&
          scrollPosition < sectionBottom
        ) {
          currentSection =
            sectionId;

          break;
        }
      }

      setActiveSection(
        currentSection
      );
    };

    window.addEventListener(
      "scroll",
      handleScroll
    );

    handleScroll();

    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll
      );
    };
  }, []);

  const scrollToSection = (
    event,
    sectionId
  ) => {
    event.preventDefault();

    const section =
      document.getElementById(
        sectionId
      );

    if (!section) {
      return;
    }

    section.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <nav className="avwakin-navbar">
      <div className="avwakin-nav-inner">
        <Link
          to="/avwakindevelopment"
          className="avwakin-logo-link"
          aria-label="Avwakin Development home"
        >
          <img
            src={logo}
            alt="Avwakin Development"
            className="avwakin-logo-img"
          />
        </Link>

        <div className="avwakin-links">
          <a
            href="#services"
            onClick={(event) =>
              scrollToSection(
                event,
                "services"
              )
            }
            className={`avwakin-link${
              activeSection ===
              "services"
                ? " active"
                : ""
            }`}
          >
            Services
          </a>

          <a
            href="#process"
            onClick={(event) =>
              scrollToSection(
                event,
                "process"
              )
            }
            className={`avwakin-link${
              activeSection ===
              "process"
                ? " active"
                : ""
            }`}
          >
            Process
          </a>

          <a
            href="#build"
            onClick={(event) =>
              scrollToSection(
                event,
                "build"
              )
            }
            className={`avwakin-link${
              activeSection ===
              "build"
                ? " active"
                : ""
            }`}
          >
            What I Build
          </a>

          <a
            href="#contact"
            onClick={(event) =>
              scrollToSection(
                event,
                "contact"
              )
            }
            className={`avwakin-link${
              activeSection ===
              "contact"
                ? " active"
                : ""
            }`}
          >
            Contact
          </a>
        </div>
      </div>
    </nav>
  );
}

export default AvwakinNavBar;